import { SET_CARE_PLAN_CONFIG, SET_CARE_PLAN_DATA } from 'redux/actions/actionTypes';

const initialState = {
  carePlanData: {},
};

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_CARE_PLAN_CONFIG: {
      return {
        ...state,
        config: payload,
      };
    }

    case SET_CARE_PLAN_DATA: {
      return {
        ...state,
        carePlanData: { ...payload },
      };
    }

    default:
      return state;
  }
};
